import React from "react";
import IconProvider from "@/components/ui/IconProvider";

interface MT_SubfolderRowProps {
  folderName: string;
  itemCount: number;
  isCollapsed: boolean;
  onToggle: () => void;
  totalWidth: number;
}

/**
 * Subfolder header row component that spans the full width of the table
 * Styled to match column headers with collapse/expand functionality
 */
const MT_SubfolderRow: React.FC<MT_SubfolderRowProps> = ({
  folderName,
  itemCount,
  isCollapsed,
  onToggle,
  totalWidth,
}) => {
  return (
    <div
      className="flex items-center cursor-pointer hover:bg-muted/80 transition-colors bg-muted border border-border font-semibold text-sm text-foreground h-[40px]"
      onClick={onToggle}
      style={{ width: totalWidth }}
    >
      <div className="flex items-center gap-2 px-4">
        <IconProvider
          iconstring={isCollapsed ? "fa-chevron-right" : "fa-chevron-down"}
          size={12}
          className="text-muted-foreground"
        />
        <span className="text-center">
          {folderName} ({itemCount})
        </span>
      </div>
    </div>
  );
};

export default MT_SubfolderRow;

